import general from "./general";
import links from "./links";


export default {
  general,
  links,
};